// Utils
import { addActiveTagToList, findTagCategoryById } from "utils/searchPage/categories";
import { handleQuerystringParams, hasQuerySearch} from "utils/searchPage/queryString";

// Types
import { Category, CurrentSelectedCategory } from "interfaces/searchPage/category";
import { FiltersInterface, Sort } from "interfaces/searchPage/osaSearch";
import { QueryString } from "interfaces/shared/queryString";

// Constants
import { QueryStringPrimaryKeys } from "constants/searchPage/urlEnum";
import {activeCourseProductStates, inactiveCourseProductStates, ProductState, ReturnFields, Sorting, SortingValue} from "constants/searchPage/gpoSearchEnum";

export const matchFilterParameters = (path: string, currentIntersectedCategories: Category[], urlPath: string) => {
	const regex = /[a-z][0-9]+/gm;
	const matches = path.match(regex);
	const selectedCategory: CurrentSelectedCategory[] = [];
	if (matches) {
		matches.forEach((match) => {
			const tagsActiveCurrently: Category[] = [];
			const macroCategory = currentIntersectedCategories.find((category) => category.urlParameter === match.slice(0, 1));
			if (macroCategory) {
				const currentTagId = parseInt(match.slice(1), 10);
				const tag = findTagCategoryById(macroCategory, currentTagId);
				addActiveTagToList(tagsActiveCurrently, tag, parseInt(match.slice(1), 10));
				handleQuerystringParams(macroCategory, currentTagId, tagsActiveCurrently, urlPath);
				if(tagsActiveCurrently.length) {
					selectedCategory.push({
						macroCategory,
						selectedTags: tagsActiveCurrently
					});
				}
			}
		});
	}
	return selectedCategory;
};

export const parsePrimaryKeysQueryString = (queryString: string): QueryString[] => {
	const queriesString: QueryString[] = [];
	const searchParams = new URLSearchParams(queryString);
	[...searchParams.keys()].forEach((key) => {
		switch (key) {
			case QueryStringPrimaryKeys.SEARCH:
				queriesString.push({
					queryStringKey: QueryStringPrimaryKeys.SEARCH,
					queryStringValue: searchParams.get(QueryStringPrimaryKeys.SEARCH) || "*"
				});
				break;
			case QueryStringPrimaryKeys.SORT:
				queriesString.push({
					queryStringKey: QueryStringPrimaryKeys.SORT,
					queryStringValue: searchParams.get(QueryStringPrimaryKeys.SORT) as Sorting || Sorting.DATE
				});
				break;
			case QueryStringPrimaryKeys.PAGE:
				queriesString.push({
					queryStringKey: QueryStringPrimaryKeys.PAGE,
					queryStringValue: searchParams.get(QueryStringPrimaryKeys.PAGE) || "1"
				});
				break;
			case QueryStringPrimaryKeys.AVAILABLE_PURCHASE_COURSES:
				queriesString.push({
					queryStringKey: QueryStringPrimaryKeys.AVAILABLE_PURCHASE_COURSES,
					queryStringValue: searchParams.get(QueryStringPrimaryKeys.AVAILABLE_PURCHASE_COURSES) || "true"
				});
				break;
			case QueryStringPrimaryKeys.SHOW_NUMBER_PRODUCTS:
				queriesString.push({
					queryStringKey: QueryStringPrimaryKeys.SHOW_NUMBER_PRODUCTS,
					queryStringValue: searchParams.get(QueryStringPrimaryKeys.SHOW_NUMBER_PRODUCTS) || "15"
				});
				break;
			default:
				queriesString.push({
					queryStringKey: QueryStringPrimaryKeys.SEARCH,
					queryStringValue: searchParams.get(QueryStringPrimaryKeys.SEARCH) || "*"
				});
		}
	});
	return queriesString;
};

export const buildPurchaseOnlyFilter = (queriesString: QueryString[]): FiltersInterface => {
	const purchaseOnlyCourse = queriesString.filter((qs) => qs.queryStringKey === QueryStringPrimaryKeys.AVAILABLE_PURCHASE_COURSES).pop();
	if (purchaseOnlyCourse) {
		return {
			fieldName: ReturnFields.PRODUCT_STATE,
			terms: [...activeCourseProductStates, ProductState.ELEARNING]
		};
	}
	return {
		fieldName: ReturnFields.PRODUCT_STATE,
		terms: [...activeCourseProductStates, ProductState.ELEARNING, ...inactiveCourseProductStates]
	};
};

export const buildGpoSearchSortPagingProductPerPageSearchQuery = (queriesString: QueryString[]) => {
	const gpoSorting: Sort[] = buildSortQuery(queriesString);
	const paging = parseInt(queriesString.filter((qs) => qs.queryStringKey === QueryStringPrimaryKeys.PAGE).pop()?.queryStringValue || "1", 10);
	const productPerPage = parseInt(queriesString.filter((qs) => qs.queryStringKey === QueryStringPrimaryKeys.SHOW_NUMBER_PRODUCTS).pop()?.queryStringValue || "15", 10);
	const querySearch = queriesString.filter((qs) => qs.queryStringKey === QueryStringPrimaryKeys.SEARCH).pop()?.queryStringValue || "*";

	return {
		gpoSorting,
		paging,
		productPerPage,
		querySearch
	};
};

export const buildSortQuery = (queriesString: QueryString[]): Sort[] => {
	const querySortField: Sort[] = [];
	const sorting = queriesString.filter((qs) => qs.queryStringKey === QueryStringPrimaryKeys.SORT).pop();
	const querySearch = queriesString.filter((qs) => qs.queryStringKey === QueryStringPrimaryKeys.SEARCH).pop();
	const sortingByDateTime = [
		{ FieldName: ReturnFields.MIN_NOT_START_DATE, OrderValue: SortingValue.ASC },
		{ FieldName: ReturnFields.MIN_START_DATE, OrderValue: SortingValue.DESC }
	];
	const sortingByRelevance = [{ FieldName: ReturnFields.SCORE, OrderValue: SortingValue.DESC }];
	const sortingByProductState = [{ FieldName: ReturnFields.PRODUCT_STATE, OrderValue: SortingValue.DESC }];

	querySortField.push(...sortingByProductState);

	if (sorting) {
		switch (sorting.queryStringValue) {
			case Sorting.ALPHABETICAL:
				querySortField.push({
					FieldName: ReturnFields.TITLE_SORTING,
					OrderValue: SortingValue.ASC
				});
				break;
			case Sorting.PRICE:
				querySortField.push({
					FieldName: ReturnFields.MINIMUM_PRICE,
					OrderValue: SortingValue.ASC
				});
				break;
			case Sorting.RELEVANCE:
				querySortField.push(...sortingByRelevance);
				break;
			default:
				querySortField.push(...sortingByDateTime);
		}
	} else if(querySearch && hasQuerySearch(querySearch.queryStringValue)) {
		querySortField.push(...sortingByRelevance);
	}else {
		querySortField.push(...sortingByDateTime);
	}
	return querySortField;
};
